import { LazyLoad } from '@petconsole/pure-fe-mui';

const PetWalkerAdmin = LazyLoad(() => import('./PetWalkerAdmin'));

export { PetWalkerAdmin };
